import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgAvatarModule } from 'shared/components/svg-avatar';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { AvatarComponent } from 'shared/components/avatar/avatar.component';

@NgModule({
  imports: [
    CommonModule,
    SvgAvatarModule,
    SvgIconModule
  ],
  declarations: [
    AvatarComponent
  ],
  exports: [
    AvatarComponent
  ]
})
export class AvatarModule {}
